import { useWindowSize } from '@vueuse/core'

export default function useWindowAspect() {
  const { width, height } = useWindowSize()
  const aspect = computed(() => width.value / height.value)
  return { aspect }
}